import { MainServicesComponent } from "./components/main-services.component";
import { MainServiceComponent } from "./components/main-service.component";
import { MainNewServiceComponent } from "./components/main-newService.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {   path: '', 
        redirectTo: 'services',
        pathMatch: 'full' 
    },
    {
        path: 'services',
        component: MainServicesComponent,
        canActivate: [AuthService],
        data: { title: 'Servicios' }
    },
    {
        path: 'services/:id',
        component: MainServiceComponent,
        canActivate: [AuthService]
    },
    {
        path: 'new-service',
        component: MainNewServiceComponent,
        canActivate: [AuthService]
    },
    {
        path: 'new-service/:idOffice',
        component: MainNewServiceComponent,
        canActivate: [AuthService]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class ServicesRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/services/services.routes.ts